<script lang="ts">
    import { selectedTab, selectTab } from "@store/pageTracker"
    import { clickEnter } from "@utils/directives/accessibility"
    import Icon from "./material/Icon.svelte"
    import ContextMenuLink from "./utilities/context-menu/ContextMenuLink.svelte"
    import ContextMenu from "./utilities/context-menu/ContextMenu.svelte"
    import ContextMenuIcon from "./utilities/context-menu/ContextMenuIcon.svelte"
    import { createEventDispatcher } from "svelte"
    import type { ComponentProps } from "svelte"

    export let positions: ComponentProps<ContextMenu>["positions"] = undefined
    export let directOpen = false

    export let showContextMenu = false
    const dispatch = createEventDispatcher()
</script>

<div
    role="button"
    tabindex="0"
    on:click={() => {
        if (directOpen || !$selectedTab) {
            dispatch("go")
        } else {
            showContextMenu = true
        }
    }}
    on:keydown={clickEnter}
    class="z-1 h-10 w-10 dark:bg-neutral-600 absolute -top-1 rounded-full -right-1 flex text-blue-900 dark:text-blue-100 items-center justify-center bg-white"
>
    <Icon icon="arrow" class="h-4 w-4 rotate-180" />
    {#if showContextMenu}
        <ContextMenu {positions} on:exit={() => (showContextMenu = false)}>
            {#if $selectedTab}
                <ContextMenuLink
                    icon="arrow"
                    cb={() => {
                        dispatch("go")
                    }}
                >
                    <div slot="icon">
                        {#if $selectedTab.emoji}
                            {$selectedTab.emoji}
                        {:else}
                            <ContextMenuIcon icon="bookmarks" />
                        {/if}
                    </div>
                    Open in {$selectedTab.displayName}
                </ContextMenuLink>
            {/if}
            <ContextMenuLink
                icon="popout"
                cb={() => {
                    selectTab("abandoned")
                    dispatch("go")
                }}>Browse</ContextMenuLink
            >
        </ContextMenu>
    {/if}
</div>
